export const menuPersonalization = {
  'menu-personalization.recommendation.label.classic': 'Something Classic',
  'menu-personalization.recommendation.label.bold': 'Something Bold',
  'menu-personalization.recommendation.label.special': 'Something Special',
  'menu-personalization.recommendation.label.generic': 'Personalized Bowl',
  'menu-personalization.recommendation.button.bowl': 'View Bowl',
  'menu-personalization.recommendation.button.salad': 'View Salad',
};
